import { Routes, Route } from 'react-router-dom';
import { lazy } from 'react';
import { LazyLoadComponent } from '@src/components/LazyLoadComponent/LazyLoadComponent';

const B2CPlansList = lazy(() =>
    import('../../pages/B2CManagement/Plans').then((module) => ({
        default: module.PlansList,
    }))
);
export function B2CPlanContainer() {
    return (
        <Routes>
            <Route
                path={'*'}
                element={
                    <LazyLoadComponent
                        type="LIST"
                        Component={<B2CPlansList />}
                    />
                }
            />
        </Routes>
    );
}
